module.exports = __webpack_public_path__ + "assets/c04c3fbaf48c2b25f515c14b4d90dcdb.png";